/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserPreference } from '../models/UserPreference';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PreferencesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns UserPreference
     * @throws ApiError
     */
    public preferencesList(): CancelablePromise<Array<UserPreference>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/preferences/',
        });
    }
    /**
     * @returns UserPreference
     * @throws ApiError
     */
    public preferencesCreate({
        requestBody,
    }: {
        requestBody: UserPreference,
    }): CancelablePromise<UserPreference> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/preferences/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns UserPreference
     * @throws ApiError
     */
    public preferencesUpdate({
        preferenceId,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this user preference.
         */
        preferenceId: number,
        requestBody: UserPreference,
    }): CancelablePromise<UserPreference> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/preferences/{preference_id}/',
            path: {
                'preference_id': preferenceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public preferencesDestroy({
        preferenceId,
    }: {
        /**
         * A unique integer value identifying this user preference.
         */
        preferenceId: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/preferences/{preference_id}/',
            path: {
                'preference_id': preferenceId,
            },
        });
    }
}
